import { TranslateService } from '@ngx-translate/core';
import { DeviceAndBrowserDetectorService } from 'src/app/services/device-and-browser-detector.service';
import { DeviceErrorType, DeviceState } from 'src/app/models/device-manger';
import { DeviceType } from '../devices-handle-util';
import {
  DeviceErrorHelperModelBase,
  DeviceErrorHelperStep,
} from './device-error-helper-model-base';

const NOT_FOUND_HELP_ARTICLE_URL =
  'https://intercom.help/pencil/en/articles/10031755-troubleshooting-no-device-detected-issue';

export class NotFoundHelper extends DeviceErrorHelperModelBase {
  private _steps: DeviceErrorHelperStep[] = [];

  constructor(
    protected deviceDetector: DeviceAndBrowserDetectorService,
    protected translateService: TranslateService,
    protected deviceType: DeviceType,
  ) {
    super(translateService, deviceDetector, deviceType);
  }

  getSteps(): DeviceErrorHelperStep[] {
    this._steps = [];
    this.constructSteps();

    return this._steps;
  }

  getMobileTitle(): string {
    return this.translateService.instant('Resolve "no device detected"');
  }

  getDesktopTitle(): string {
    return this.translateService.instant('Resolve "no device detected"');
  }

  hasRelatedError(cam: DeviceState, mic: DeviceState) {
    return (
      this.hasErrorOfType(cam, DeviceErrorType.NOT_FOUND) ||
      this.hasErrorOfType(mic, DeviceErrorType.NOT_FOUND)
    );
  }

  showRefreshButton(): boolean {
    return false;
  }

  getErrorMsg(cam: DeviceState, mic: DeviceState): string {
    const camError = this.hasErrorOfType(cam, DeviceErrorType.NOT_FOUND);
    const micError = this.hasErrorOfType(mic, DeviceErrorType.NOT_FOUND);

    if (camError && micError) {
      return this.translateService.instant('cam and mic not yet found');
    } else if (camError) {
      return this.translateService.instant('Cam not yet found');
    } else if (micError) {
      return this.translateService.instant('Mic not yet found');
    } else {
      return '';
    }
  }

  constructSteps() {
    this._steps = [
      {
        stepText:
          `${this.translateService.instant("If you're using an external camera or mic, try")} ` +
          `${this.strongHtml(this.translateService.instant('unplugging'))} ` +
          `${this.translateService.instant('and')} ` +
          `${this.strongHtml(this.translateService.instant('reconnecting'))} ` +
          `${this.translateService.instant('them')}`,
        stepImgSrc: 'helper-modal-guides/notFoundSteps/step-1.png',
      },
      {
        stepText:
          `${this.translateService.instant('Ensure that your camera and mic are')} ` +
          `${this.strongHtml(this.translateService.instant('enabled'))} ` +
          `${this.translateService.instant('in')} ` +
          `${this.strongHtml(this.translateService.instant('System Settings'))}`,
        stepImgSrc: 'helper-modal-guides/notFoundSteps/step-2.png',
      },
      {
        stepText:
          `${this.translateService.instant('If issues persist, review our')} ` +
          `${this.externalHelpLinkHtml(
            NOT_FOUND_HELP_ARTICLE_URL,
            this.translateService.instant('help doc'),
          )} ` +
          `${this.translateService.instant('or')} ${this.strongHtml(
            this.translateService.instant('contact support'),
          )}.`,
      },
    ];
  }
}
